module.exports = __webpack_public_path__ + "assets/img/title-0e6c0040.png";